import { Component, OnInit, Input, ElementRef, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';
import { ItineraryService } from '../../shared/itinerary.service';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import * as moment from 'moment';
import { setting } from '../../../../setting';
import CssFilterConverter from 'css-filter-converter';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'usb-summary-reservation',
  templateUrl: './summary-reservation.component.html',
  styleUrls: ['./summary-reservation.component.scss']
})
export class SummaryReservationComponent implements OnInit {

  @Input() step:string;
  @Input() itineraryItems: any = [];
  @Input() itineraryTotal: any;
  @Input() itinerary:any;
  @Input() totalPasajeros: any;
  @Input() styleSidebar: any;
  @Input() currencies: any[];
  @Input() getClientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Output() addFormEmitType = new EventEmitter();
   @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
    @ViewChildren('icons_two', { read: ElementRef }) icons_two: QueryList<ElementRef>;
        @ViewChildren('icons_lugagge', { read: ElementRef }) icons_lugagge: QueryList<ElementRef>;

  totalTarifaNeta  :number = 0;
  totalTarifa  :number = 0;
  totalBlickoins = 0;
  dateItinerary:string = '';

  price: number;
  blickoins: number;
  totalCreditBlickoins: number;
  totalNetPriceBookingFreeTax: number;
  taxNightsPriceTotal: number;
  public taxSum: number = 0;
  public currencyItinerary: string
  fontSizeAdjustments = { 4: 0, 6: -2, 9: -6 };
      filterColorIcon: any;
        buttonTextActive: string = '';

  constructor(public serviceItinerary: ItineraryService, public userService:UserService, public toastr: ToastrService)
    {
    }

  ngOnInit() {
    console.log(this.itineraryItems)
    const bookingFlow_sidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.dataTax(this.itineraryItems);
    this.itineraryItems.forEach(item => {
      const destiny = this.itinerary.destination.find(element=> element.iata_code == item.destination.iata_code);
      item.cityame = destiny.destination_info.cityName;
      this.price = item.netPriceAgent;
      this.blickoins = Number(item.profility.blickoins);
      // console.log('blickoins', this.blickoins);
      this.totalCreditBlickoins = item.profility.creditBlickoins;
      // console.log('total Blickoins', this.totalBlickoins);
      this.totalNetPriceBookingFreeTax = item.optionNightsNetTotalFreeTax;
      this.taxNightsPriceTotal = item.taxNightsPriceTotal;
      this.totalNetPriceBookingFreeTax = this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.optionNightsNetTotalFreeTax), 0);
      this.taxNightsPriceTotal =  this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.taxNightsPriceTotal), 0);
    });

    this.totalTarifaNeta = this.itinerary.totalNetPriceBooking;
    this.totalTarifa  = this.itinerary.totalNetPriceAgent;
    this.totalBlickoins =  this.itinerary.totalBlickoins;
    this.totalCreditBlickoins = this.itinerary.totalCreditBlickoins;
    this.currencyItinerary = this.itineraryItems[0]?.currency;
    localStorage.setItem('totalNetReserved', this.itinerary.totalPriceByNetReserved);
    localStorage.setItem('totalReserved', this.itinerary.totalPriceByReserved);


    this.price = this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.netPriceAgent), 0);
    this.blickoins = this.itineraryItems.reduce((sum, item) => sum + Number(item.profility.blickoins), 0);
    this.totalCreditBlickoins = this.itineraryItems.reduce((sum, item) => sum + Number(item.profility.creditBlickoins), 0);
  }


  private dataTax(data: any) {
    if (data && data.length > 0) {
      // Recorre cada producto en los datos
      data.forEach((product) => {
        // Verifica por categoría de hoteles para evitar conflictos con otras categorías y sus precios.
        if(product.categoryName == 'HOTELS'){
          // Verifica si hay taxes en el ítem
          if (product.room.pricing.taxes && Array.isArray(product.room.pricing.taxes)) {
            // Recorre cada impuesto en las taxes
            product.room.pricing.taxes.forEach((tax) => {
              // Verifica si 'included' es un booleano verdadero
              if (typeof tax.included === 'boolean' && tax.included) {
                // Si 'included' es true, suma el impuesto al total
                if(tax.currency !== this.currencyAgency?.code) {

                  tax.amount = tax.amount / this.currencies.find(c => c.code === 'USD').rate;

                  this.taxSum += tax.amount * this.currencyAgency?.rate;
                } else {
                  this.taxSum += tax.amount;
                }
              }
            });
          }
        }

      });
    }
    // Formatea el resultado con dos decimales
    this.taxSum = parseFloat(this.taxSum.toFixed(2));
    this.applyImageFilter();

  }


  setDateHead(date?:string) {
    if (date) {
      let dateSplit = date.split("-");
      return '' + dateSplit[2] + ' ' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }else{
      return '';
    }
  }


  verifyCityExist(i){

    if(this.itineraryItems[i-1]){

      if(this.itineraryItems[i-1].destination.iata_code ==  this.itineraryItems[i].destination.iata_code){

        return true;
      }else{
        return false;
      }
      //console.log("")
    }else{
      return false;
    }

  }

  extractNameTransport(form: any, type: string, itemPayload: any): string {
    switch(type) {
      case 'origin':
        switch(itemPayload.transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.name || form.hotel_name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
      case 'destination':
        switch(itemPayload.transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.name ||form.hotel_name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
    }
  }

      getTypeWay(typeWay: any): string {

    if(typeWay !== undefined) {
      return typeWay === 1 ? 'IDA' : 'VUELTA';
    } else {
      return '  ';
    }
  }

      getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  let messageFly: string = '';
  // const messageFly = 'Hora arribo del vuelo';
  if(input === 'origin') {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  } else {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  }

  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

     applyImageFilter() {
          const color = this.styleSidebar?.color;
          const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

          //Extraemos el literal en String de la conversión
          const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

          // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
          const colorRegex = /color\((.*)\)/;
          const colorMatch = tempFilterStr.match(colorRegex);
          const colorFilter = colorMatch ? colorMatch[1] : "";

          this.filterColorIcon = colorFilter;
          // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
          setTimeout(() => {
            this.icons_lugagge.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 21px;`);
            });
            this.icons.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 16px;`);
            });

             this.icons_two.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 14px;`);
            });
           // console.log(this.filter);
          }, 100);
        }


          getNetTarifa() {
            let price = 0;
            // price = this.itinerary.totalNetPriceBooking ? this.itinerary.totalNetPriceBooking  : 0;
            price = this.calculateTotal('netPriceBookingFreeTax');
            return price;
          }


          getTotalTarifa() {
            let price = 0;
            //  price = this.itinerary.totalNetPriceAgent ? this.itinerary.totalNetPriceAgent  : 0;
            price = this.calculateTotal('netPriceAgent');
            return price;
          }

          getComission() {
            let comission = 0;
            comission =  this.calculateTotal('fee');
            // comission = this.itinerary.totalFee ? this.itinerary.totalFee  : 0;
            return comission
          }



private calculateTotal(fieldName: string): number {

    return this.serviceItinerary.calculateTotal(
                                                fieldName,
                                                this.itinerary,
                                                this.currencies,
                                                this.currencyAgency);

}

addForm(type: string): void {
  const validation = this.validatePassengerAddition(type);
  if (!validation.valid) {
    this.toastr.info(validation.message);
    return;
  }
  this.addFormEmitType.emit(type);
}

private validatePassengerAddition(type: string): { valid: boolean, message?: string } {
  const typeConfig = {
    'adult': { limit: this.totalPasajeros.maxAdults, name: 'adultos' },
    'children': { limit: this.totalPasajeros.maxChildren, name: 'niños' }
  };

  const currentCount = this.totalPasajeros.paxes.filter(c => c.type === type).length;

  if (currentCount >= typeConfig[type].limit) {
    return {
      valid: false,
      message: `Ya eligió todos los pasajeros ${typeConfig[type].name} admitidos para esta reserva`
    };
  }

  return { valid: true };
}

getDurationTour(item): string {

  if(item.scheduling && Array.isArray(item.scheduling) && item.scheduling.length > 0) {
    return `${item.scheduling[0]?.duration?.value} ${item.scheduling[0]?.duration?.metric === 'HOURS' ? 'hs.' : 'min.'}`;
  }

  return '';
}

// private parseNumber(value:any):number{
//   if(value == null || value == '') return 0;

//   return parseFloat(String(value).replace(/\./g, '').replace(',', '.')) || 0;
// }

}
